<script lang='ts'>
import { Link, useNavigate, useLocation } from "svelte-navigator";
import { loginUser } from "../store";
import { getPath, getHeaders, postJson } from '../services';
import * as config from '../config.json'

export let title;
export let subtitle;

interface SetPreinvitePasswordResponse {
  id: string;
  token: string;
  first: string;
  last: string;
}

const emailExists = async (email) => {
  const response = await fetch(getPath('preinvite-email-exists'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({email, companyId: config.companyId, eventId: config.eventId})
  });

  if (response.status >= 200 && response.status < 300) return true;
  throw new Error(await response.text());
}

const setPreinvitePassword = (email, password) =>
  postJson<SetPreinvitePasswordResponse>('preinvite-set-password', {email, password, companyId: config.companyId, eventId: config.eventId}).then(resp => {
    localStorage.setItem('token', resp.token)
    return resp;
  });

const navigate = useNavigate();
const location = useLocation();

let email = '';
let password = '';
let passwordConfirm = '';
let token;
let valid;

// $: {
//   const params = new URLSearchParams($location.token);
//   token = params.get('token')
//   valid = token.length > 0;
// }

let error;

let page = 0;

let checkingEmail = false;

async function checkEmail() {
  checkingEmail = true;
  error = undefined;
  try {
    const found = await emailExists(email)
    if (found) page = 1;
    else error = true;
  } catch (e) {
    error = true;
  } finally {
    checkingEmail = false;
  }
}

async function submit() {
  if (password.length < 6) {
    error = "Password must be at least 6 characters";
    return;
  }

  if (password !== passwordConfirm) {
    error = "Passwords do not match";
    return;
  }

  error = undefined

  try {
    const {first, last, id, token} = await setPreinvitePassword(email, password);
    loginUser(id, token, email, first, last)
    navigate('/', { replace: true });
  } catch (e) {
    error = e.message;
  }
}
</script>

<div class="login-title">
  {@html title}
</div>

{#if page === 0}
  <div class="login-subtitle">
    {@html subtitle}
  </div>

  <form on:submit|preventDefault={checkEmail}>
    <div class="col mb-4">
      <div class="form-label">Email</div>
      <input bind:value={email} type="email" name="email" placeholder="Email" />
    </div>

    {#if error}
      <div class="error-box">
        We're sorry but your e-mail address was not found. Please confirm spelling. If you did not receive an invite please contact the help desk.
      </div>
    {/if}

    <div class="row vcenter between login-help-link" style="margin-top: 48px">
      <Link to="/signin">Already have an account?</Link>
      <button type="submit" class="button secondary">Continue</button>
    </div>
  </form>
{:else if page === 1}
  <div class="login-subtitle">
    Welcome! Please create a password for your account.
  </div>

  <form on:submit|preventDefault={submit}>
    <div class="col mb-4">
      <div class="form-label">Password</div>
      <input bind:value={password} type="password" name="password" placeholder="Password" />
    </div>

    <div class="col mb-4">
      <div class="form-label">Confirm Password</div>
      <input bind:value={passwordConfirm} type="password" name="password" placeholder="Password" />
    </div>

    {#if error}
      <div class="error-box">
        {error}
      </div>
    {/if}

    <div class="row vcenter between" style="margin-top: 48px">
      <div class="login-help-link" on:click={() => page = 0}>Return to Email Login</div>
      <button type="submit" class="button secondary">SIGN UP</button>
    </div>
  </form>
{/if}